import AfEventApi from '@/api/afevent';

const SubscribeEventApi = {
  /**
   * 대상자 조회, 현재 남은 수량 확인 api
   * @param type , ChkUserSubscriptionEvent(이벤트 대상자인지 체크), GetSubscriptionEventNewStreamerCnt(이벤트 누적 개수)
   * @return {Promise<void>}
   */
  subscribeRenewalEventInfo: async (type) => {
    try {
      const response = await AfEventApi.get(
        `/api/subscription_renewal_event_api.php?type=${type}`,
      );
      return response;
    } catch (e) {}
  },
};
export default SubscribeEventApi;
